import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { IconEdit } from "../icons/IconEdit";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonEdit: React.FC<MprcButtonProps> = ({ text, title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonEdit.text;
    const lTitle = title || theme.buttons.ButtonEdit.title;
    return (
        <MprcButton
            {...rest}
            title={lTitle}
            text={lText}
            startIcon={<IconEdit fixedWidth />}
        />
    );
};
